import PingAuthTokens from './PingAuthTokens';

export interface PingAuthInfo {
    tokens: PingAuthTokens;
    startDate: Date;
    expiryDate: Date;
    expiresIn: number;
}

export const emptyAuthInfo: PingAuthInfo = {
    tokens: {accessToken: '', refreshToken: '', idToken: ''},
    expiryDate: new Date(),
    startDate: new Date(),
    expiresIn: 0,
};

export interface PingAuthInfoCookie {
    tokens: PingAuthTokens;
    startDate: string;
    expiryDate: string;
    expiresIn: number;
}
